var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "code-samples"
  }, [_c('div', {
    staticClass: "code-pills"
  }, [_c('div', {
    staticClass: "code-pill",
    class: {
      active: _vm.activeCodeSample === 'curl'
    },
    on: {
      "click": function($event) {
        _vm.activateCodeSample('curl')
      }
    }
  }, [_vm._v("CURL")]), _vm._v(" "), _c('div', {
    staticClass: "code-pill",
    class: {
      active: _vm.activeCodeSample === 'php'
    },
    on: {
      "click": function($event) {
        _vm.activateCodeSample('php')
      }
    }
  }, [_vm._v("PHP")])]), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "code-sample",
    class: {
      hidden: _vm.activeCodeSample !== 'curl'
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "code-sample",
    class: {
      hidden: _vm.activeCodeSample !== 'php'
    }
  }, [_vm._m(1)])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', [_c('code', {
    staticClass: "bash",
    attrs: {
      "id": "curl"
    }
  }, [_vm._v("\n# As simple as ABC\ncurl -H \"Authorization: {api_key}\" \\\nhttps://api.jsonwhoisapi.com/v1/whois?identifier=google.com\n      ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', [_c('code', {
    staticClass: "PHP",
    attrs: {
      "id": "php"
    }
  }, [_vm._v("\n// Set authentication information\nUnirest\\Request::auth($customer_id, $api_key);\n$headers = array(\"Accept\" => \"application/json\");\n$url = \"https://jsonwhoisapi.com/api/v1/whois?identifier=google.com\";\n$response = Unirest\\Request::get($url, $headers);\n      ")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ad24568","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/home/code-samples.vue
// module id = 666
// module chunks = 0